import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationCaseAdvancedFilterOptions } from '../models/dto/case-search/application-case-advanced-filter-options.model';
import { BaseCaseSearchResultDto } from '../models/dto/case-search/base-case-search-result-dto.model';
import { CaseSearchResponseResult } from '../models/dto/case-search/case-search-response-result';
import { LinkedCaseDetailsDto } from '../models/dto/linked-case-details-dto.model';
import { BaseHubService } from './base-hub.service';

@Injectable()
export class BaseCaseHubService<T extends BaseCaseSearchResultDto> extends BaseHubService<
  ApplicationCaseAdvancedFilterOptions,
  T,
  CaseSearchResponseResult<T>
> {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
  }

  public getLinkedCaseDetails(caseId: string): Observable<LinkedCaseDetailsDto> {
    const params = new HttpParams().set('caseNumber', caseId);

    return this.httpClient
      .get('/ApplicationCase/GetLinkedCaseDetails', { params })
      .pipe(map((data: any) => new LinkedCaseDetailsDto().deserialize(data)));
  }
}
